import { motion, AnimatePresence } from "framer-motion";
import ShimmerCard from "./ShimmerCard";
import {TrendingUp } from "lucide-react";

export default function PlayerPurchaseModal({ player, onClose, ownedPlayers }) {
  if (!player) return null;

  const particleCount = 12;

  const spawnParticles = () =>
    Array.from({ length: particleCount }).map((_, i) => {
      const angle = Math.random() * 2 * Math.PI;
      const radius = 60 + Math.random() * 40;
      return {
        id: i,
        x: Math.cos(angle) * radius,
        y: Math.sin(angle) * radius,
        scale: Math.random() * 0.5 + 0.5,
      };
    });

  const particles = spawnParticles();

  const positiveUpgrade = (() => {
    const sameRolePlayer = ownedPlayers.find((p) => p.players.role === player.role && p.is_starter);
    if (!sameRolePlayer) return null;

    const currentPoints = sameRolePlayer.players.projected_points;
    const newPoints = player.projected_points;

    if (newPoints <= currentPoints) return null;

    const diffPercent = Math.round(((newPoints - currentPoints) / currentPoints) * 100);
    return {
      currentPlayer: sameRolePlayer.players.name,
      diffPercent,
      role: player.role,
    };
  })();

  return (
    <AnimatePresence>
      <motion.div
        className="modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.9)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999,
        }}>
        <motion.div
          className="modal-matchup"
          onClick={(e) => e.stopPropagation()}
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.6, opacity: 0 }}
          transition={{ type: "spring", stiffness: 500, damping: 25 }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0,
            background: "#0b131e00",
            border: "1px solid #0b131e00",
            position: "relative",
            padding: "20px",
            borderRadius: "16px",
          }}>
          {/* Header */}
          <motion.h2
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            style={{
              margin: 0,
              fontWeight: 800,
              textShadow: "rgba(0, 0, 0, 0.6) 0px 0px 20px",
              zIndex: 99,
              textAlign: "center"
            }}>
            Player Purchase Successful
          </motion.h2>
          {/* Positive Upgrade Indicator */}
          {positiveUpgrade && (
            <div
              style={{
                marginTop: "12px",
                padding: "6px 12px",
                background: "rgba(0, 255, 144, 0.2)",
                color: "#00ff90",
                borderRadius: "8px",
                fontSize:  "14px",
                fontWeight: "700",
                gap: "6px",
                zIndex: "99",
                textAlign: "center",
                display: "flex", alignItems: "center"
              }}>
              <TrendingUp />{player.name} is {positiveUpgrade.diffPercent}% better than your current {positiveUpgrade.role} ({positiveUpgrade.currentPlayer})
            </div>
          )}
          {/* Player Card */}
          <motion.div
            initial={{ scale: 0.7, rotate: -5, opacity: 0 }}
            animate={{ scale: 1, rotate: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 600, damping: 25 }}
            style={{ position: "relative", zIndex: 99, margin: "20px 0" }}>
            <ShimmerCard
              rarity="default"
              style={{
                boxShadow: "0 15px 35px rgba(0,0,0,0.5), 0 0 50px rgba(255, 255, 255, 0.2), 0 0 80px rgba(255, 255, 255, 0.3)",
                borderRadius: "20px",
              }}>
              <img src={`/players/${player.player_image}`} alt={player.name} className="player-purchase-img" />
            </ShimmerCard>
          </motion.div>

          {/* Particle Burst */}
          {particles.map((p) => (
            <motion.div
              key={p.id}
              style={{
                position: "absolute",
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: "gold",
                top: "50%",
                left: "50%",
                zIndex: 0,
              }}
              initial={{ x: 0, y: 0, scale: p.scale, opacity: 1 }}
              animate={{ x: p.x, y: p.y, scale: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            />
          ))}

          {/* Player Info */}
          <motion.h3
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
            style={{
              margin: "10px 0 0 0",
              textTransform: "uppercase",
              fontWeight: 900,
              fontSize: "26px",
              fontStyle: "italic",
              zIndex: 99,
              textShadow: "rgba(0, 0, 0, 0.6) 0px 0px 20px",
            }}>
            {player.name}
          </motion.h3>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 0.7 }} transition={{ delay: 0.5 }}>
            {player.teams?.name} • {player.role}
          </motion.p>

          <motion.button
            onClick={onClose}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 500, damping: 20, delay: 0.6 }}
            style={{
              marginTop: "20px",
              padding: "8px 20px",
              borderRadius: "8px",
              background: "gold",
              color: "#111",
              fontSize: "18px",
              border: "1px solid #956b1a",
              fontWeight: "bold",
              cursor: "pointer",
            }}>
            Continue
          </motion.button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
